module.exports = __webpack_public_path__ + "static/media/destino.1d3be22b.svg";